import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";

const { forwardRef, useImperativeHandle } = React;

const SliderTageSelect = forwardRef(
  ({ oldSliderTags, onChange, label }, ref) => {
    const [sliderTags, setSliderTags] = useState([]);
    const [sliderTagsOption, setSliderTagsOption] = useState([]);
    const [selectedSliderTags, setSelectedSliderTas] = useState([]);

    useImperativeHandle(ref, () => ({
      afterSubmit() {
        setSelectedSliderTas([]);
      },
    }));

    const { utils } = useSelector(utilsState);

    useEffect(() => {
      if (utils?.SLIDERS_TAGS_VALUES?.length) {
        setSliderTags(utils.SLIDERS_TAGS_VALUES);
      }
    }, [utils]);

    useEffect(() => {
      let newCategory = [];
      sliderTags?.map((item) =>
        newCategory.push({
          value: item.value,
          label: item.name,
        })
      );
      setSliderTagsOption(newCategory);
    }, [sliderTags]);

    function handleSliderTags(data) {
      setSelectedSliderTas(data);
      const newData = data.map((item) => {
        return item.value;
      });
      console.log("newData----------",newData);

      onChange(newData || []);
    }

    useEffect(() => {
      if (oldSliderTags?.length > 0) {
        let selectedSliderTags = [];
        for (let i = 0; i < oldSliderTags?.length; i++) {
          let isExist = sliderTags.filter((item) => {
            return item.value === oldSliderTags[i];
          });
          selectedSliderTags.push({
            value: isExist[0]?.value,
            label: isExist[0]?.name,
          });
        }
        setSelectedSliderTas(selectedSliderTags);
      }
    }, [oldSliderTags, sliderTags]);

    return (
      <div>
        {label ? (
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            {label}
          </label>
        ) : null}
        <Select
          className=""
          options={sliderTagsOption}
          placeholder="انتخاب تگ اسلایدر"
          value={selectedSliderTags}
          onChange={handleSliderTags}
          isSearchable={true}
          isMulti
        />
      </div>
    );
  }
);

export default SliderTageSelect;
